import { SelectRow, UseTableSelect } from "@/common/hooks/useTableSelect";
import Checkbox from "../Checkbox";
import { useEffect } from "react";

interface RowCheckboxProps {
  row: any;
  tableSelect: UseTableSelect;
}

const RowCheckbox = ({
  row,
  tableSelect,
}: RowCheckboxProps) => {
  const key = (row as SelectRow)[tableSelect.keyExtractor];

  useEffect(() => {
    if (row.checkboxEnabled !== false) {
      tableSelect.setItems((prev) => ({ ...prev, [key]: prev[key] || false }));
    }
  }, [key]);

  return (
    <td
      className={'py-4 px-5 border-x border-x-white-200 font-normal text-neutral-4 text-left'}
      key={`table_select_${key}`}
    >
      {row.checkboxEnabled !== false && (
        <Checkbox
          label=""
          name=""
          labelContainerClassName="hidden"
          checked={tableSelect?.items?.[(row as SelectRow)[tableSelect.keyExtractor]]}
          onChange={(event) => tableSelect?.selectItem(row, event.currentTarget.checked)}
        />
      )}
    </td>
  );
};

export default RowCheckbox;
